<template>
  <div id="app">
    <template v-if="loading == '0'">
      <div class="loading">
        <van-loading size="24px" vertical>{{ $t("加载中") }}...</van-loading>
      </div>
    </template>

    <template v-if="loading == '1'">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </template>
  </div>
</template>

<script setup>
// import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi'

// import { mainnet, arbitrum } from 'viem/chains'
// import { reconnect } from '@wagmi/core'

// // 1. Define constants
// const projectId = '2407c16ee7ecd6f022dcb533b6a38c51'

// // 2. Create wagmiConfig
// const metadata = {
//   name: 'Web3Modal',
//   description: 'Web3Modal Example',
//   url: 'https://xspace.ws', // origin must match your domain & subdomain
//   icons: ['https://avatars.githubusercontent.com/u/37784886']
// }

// const chains = [mainnet, arbitrum]
// const config = defaultWagmiConfig({
//   chains, // required
//   projectId, // required
//   metadata, // required
//   enableWalletConnect: true, // Optional - true by default
//   enableInjected: true, // Optional - true by default
//   enableEIP6963: true, // Optional - true by default
//   enableCoinbase: true // Optional - true by default
// })

// reconnect(config)
// // 3. Create modal
// createWeb3Modal({
//   wagmiConfig: config,
//   projectId,
//   enableAnalytics: true // Optional - defaults to your Cloud configuration
// })
</script>

<script>
import { getEnums, getLanguage, setCommonData } from "@/utils/auth";
import { detect } from "@/utils/index";
import { getCommonData } from "@/config/global_data";
export default {
  name: "App",
  data() {
    return {
      commonData: {},
      loading: -1,
    };
  },
  mounted() {
    if (!getEnums()) {
      this.$api.common.enums().then((res) => {
        this.$store.dispatch("setEnums", res.data);
      });
    }
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
    getCommonData().then((res) => {
      this.commonData = res.data;
      let deviceType = detect();
      let loading;
      if (deviceType === "ios") {
        loading = res.data.ios_app_status;
      } else if (deviceType === "android") {
        loading = res.data.android_app_status;
      } else if (deviceType === "windows") {
        loading = res.data.h5_status;
      }
      this.loading = loading;
      setCommonData(res.data);
      // let jsStr = this.commonData.javascript.replace(/\<script type=\"text\/javascript\">/g, '')
      // jsStr = jsStr.replace(/<\/script>/g, '')
      // jsStr = jsStr.replace(/<script>/g, '')
      // console.log(jsStr)
      // eval(jsStr)
      let jsStr = this.commonData.javascript;
      this.$store.dispatch("setServiceLink", jsStr);
      //语言对照表
      const languageMappings = {
        zh: "zh-hk",
        en: "en", //英文
        ja: "ja-jp", //日文
        ar: "ar", //阿拉伯
        fr: "fr", //法语
        de: "de", //德语
        es: "es", //西班牙
        it: "it", //意大利
        id: "id", //印尼
        th: "th", //泰语
        tr: "tr", //土耳其
        vi: "vi", //越南
        ko: "ko", //韩语
        //香港台湾全部对照繁体
        "zh-cn": "zh-hk",
        "zh-hk": "zh-hk",
        "zh-tw": "zh-hk",
      };
      // console.log(navigator.language.toLowerCase(),'设备语言')
      const localStorageKey = "default_language";
      const storedLanguage = localStorage.getItem(localStorageKey);
      if (!storedLanguage) {
        //不读取设备语言了 默认走设置的 设置没有走接口 接口跟设置都没有走英文
        // const la = navigator.language.toLowerCase();
        const defaultLanguage = res.data.default_language || "en";
        localStorage.setItem(localStorageKey, defaultLanguage);
        const lang = getLanguage();
        if (lang !== defaultLanguage) {
          this.$store.dispatch("setLanguage", defaultLanguage);
        }
      }
    });
    //监听set变化
    const signSetItem = localStorage.setItem;
    localStorage.setItem = function (key, val) {
      let setEvent = new Event("setItemEvent");
      setEvent.key = key;
      setEvent.newValue = val;
      window.dispatchEvent(setEvent);
      signSetItem.apply(this, arguments);
    };
    //设置默认主题色
    let theme = localStorage.getItem("theme")
      ? localStorage.getItem("theme")
      : "light";
    if (!localStorage.getItem("theme")) {
      localStorage.setItem("theme", 'light')
    }
    document.documentElement.setAttribute("theme", theme);
  },
  methods: {},
};
</script>

<style>
* {
  -webkit-touch-callout: none;
  /* 系统默认菜单被禁用 */
  -webkit-user-select: none;
  /* webkit浏览器*/
  -moz-user-select: none;
  /* 火狐*/
  -ms-user-select: none;
  /* IE10*/
  user-select: none;
}

input,
textarea {
  -webkit-user-select: auto;
}

:root[theme="light"] {
  /*白天主题*/
  --bgColor: #fff;
  /*白天大的背景颜色*/
  --textColor: #333333;
  /*白天文本颜色*/
  --divtextColor: #999999;
  /*二类文本颜色*/
  --divbgColor: #f4f4f4;
  /*二类盒子的背景颜色*/
  --borderColor: #e5e5e599;
  /*下划线颜色*/
  --divbgLight: #f4f4f4;
  /*二类盒子浅色背景*/
  --divbgAssist: #e6e6e6;
  /*辅助浅色背景*/
  --chartGridColor: #eeeeee;
  /*K线图网格颜色*/
  --optionsGridPrimary: #3CB371;
  --optionsGridSecondary: #07c06a;
  --optionsGridBg1: #c5c5c5;
  --optionsGridBg2: #dedede;
  --homeText: #999999;
  --homeBg: #e5e5e599;
  --homebd: rgba(0, 0, 0, 0.9);
  --homebd1: rgba(0, 0, 0, 0.8);
  --vipBg: #f4f4f4;
  --flowBg: #e6e6e6;
  --flowText: #33333390;
}

:root[theme="dark"] {
  /*晚上主题*/
  --bgColor: #111111;
  /*晚上大的背景颜色*/
  --textColor: #fff;
  /*晚上文本颜色*/
  --divtextColor: #666666;
  /*二类文本颜色*/
  --divbgColor: #1f1f1f;
  /*二类盒子的背景颜色*/
  --borderColor: #33333399;
  /*下划线颜色*/
  --divbgLight: #1f1f1f;
  /*二类盒子浅色背景*/
  --divbgAssist: #999999;
  /*辅助浅色背景*/
  --chartGridColor: #2b2b2b;
  /*K线图网格颜色*/
  --optionsGridPrimary: #3CB371;
  --optionsGridSecondary: #07c06a;
  --optionsGridBg1: #1b2137;
  --optionsGridBg2: #2c324e;
  --homeText: #fff;
  --homeBg: #282828;
  --homebd: rgba(255, 255, 255, 0.9);
  --homebd1: rgba(255, 255, 255, 0.8);
  --vipBg: #1f1f1f;
  --flowBg: #282828;
  --flowText: #999999;
}

#app {
  width: 100%;
  max-width: 750px;
  height: 100%;
  margin: 0 auto;
  background: var(--bgColor);
}

body {
  background: var(--bgColor);
}

html {
  background: var(--bgColor);
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.hx {
  width: 100%;
  height: 0.2rem;
  background: #f5f5f5;
}

.loading {
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.5;
}

.van-loading {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.van-popup {
  max-width: 750px;
}

.van-tabs__line {
  width: 1.2rem;
  background-color: #136df9;
}

.van-tabs--card>.van-tabs__wrap {
  height: 0.8rem !important;
}

.van-tabs__nav--card {
  height: 0.8rem !important;
  line-height: 0.8rem !important;
  border: none;
  border-radius: 0.16rem;
}

.van-tabs__nav--card .van-tab {
  font-size: 0.3rem;
  color: #67a2ff;
  /* height: 0.8rem; */
  line-height: 1.2rem !important;
  border-radius: 0.16rem;
  /* background: #fff; */
  border: none !important;
}

.van-tabs__nav--card .van-tab.van-tab--active {
  background-color: #07c06a !important;
  color: #fff;
}

.van-cell__value {
  overflow: initial;
}

.red {
  color: #f85367;
}

.green {
  color: #1fae87;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue